import { GameConstants } from "../../GameConstants";
import { Piece } from "../../board/Piece";
import { GameVars } from "../../GameVars";
import { HelpLayer } from "./HelpLayer";

export class InstructionsBoard extends Phaser.Group {

    private static KNIGHT_MOVEMENTS: number[][] = [
        [ 1.5 * GameConstants.SQUARE_WIDTH, -1.5 * GameConstants.SQUARE_WIDTH],
        [ 2.5 * GameConstants.SQUARE_WIDTH, -.5 * GameConstants.SQUARE_WIDTH],
        [ 2.5 * GameConstants.SQUARE_WIDTH, 1.5 * GameConstants.SQUARE_WIDTH],
        [ 1.5 * GameConstants.SQUARE_WIDTH, 2.5 * GameConstants.SQUARE_WIDTH],
        [ -.5 * GameConstants.SQUARE_WIDTH, 2.5 * GameConstants.SQUARE_WIDTH],
        [ -1.5 * GameConstants.SQUARE_WIDTH, 1.5 * GameConstants.SQUARE_WIDTH],
        [ -1.5 * GameConstants.SQUARE_WIDTH, -.5 * GameConstants.SQUARE_WIDTH],
        [ -.5 * GameConstants.SQUARE_WIDTH, -1.5 * GameConstants.SQUARE_WIDTH]
    ];

    private knightIndexMovement: number;

    private rook: Piece;
    private rightRook: Piece;
    private leftRook: Piece;
    private king: Piece;
    private marker: Phaser.Sprite;
    private bishop: Piece;
    private knight: Piece;
    private queen: Piece;
    private line: Phaser.Image;
    private lineCap: Phaser.Image;
    private movementPawn1: Piece;
    private movementPawn2: Piece;
    private movementPawn3: Piece;
    private movementPawn4: Piece;
    private movementPawnBishop: Piece;
    private movementPawnRook: Piece;
    private promotionPawn1: Piece;
    private promotionPawn2: Piece;
    private promotionPawn3: Piece;
    private promotionPawn4: Piece;
    private promotionRook: Piece;
    private promotionKnight: Piece;
    private promotionBishop: Piece;
    private promotionQueen: Piece;
    private enPassantPawnWhite: Piece;
    private enPassantPawnBlack: Piece;

    constructor(game: Phaser.Game) {

        super(game, null, "board");

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = 340;

        this.scale.x = .65;
        this.scale.y = GameVars.scaleY * .65;

        const board = new Phaser.Sprite(this.game, 0 , 0 , "texture_atlas_1", "board_void.png");
        board.anchor.set(.5);
        this.add(board);

        this.line = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "black_line.png");
        this.line.anchor.y = .5;
        this.line.visible = false;
        this.add(this.line);

        this.lineCap = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "black_line_cap.png");
        this.lineCap.anchor.set(1, .5);
        this.lineCap.visible = false;
        this.add(this.lineCap);

        switch (HelpLayer.currentPage) {
            case 1:
                this.setBoard1();
                break;
            case 2:
                this.setBoard2(); // PAWN MOVEMENT
                break;
            case 3:
                this.setBoard3(); // PAWN PROMOTION
                break;
            case 4:
                this.setBoard4(); // TORRE
                break;
            case 5:
                this.setBoard5();
                break;
            case 6:
                this.setBoard6();
                break;
            case 7:
                this.setBoard7(); // LA REINA
                break;
            case 8:
                this.setBoard8(); // EL REY
                break;
            case 9:
                this.setBoard9(); // CASTLING
                break;
            case 10:
                this.setBoard10(); // EN PASSANT
                break;
            case 11:
                this.setBoard11(); // check
                break;
            case 12:
                this.setBoard12(); // CHECKMATE
                break;
            case 13:
                this.setBoard13();
                break;
            default:
        }
    }

    public destroy(destroyChildren?: boolean, soft?: boolean): void {

        super.destroy(destroyChildren, soft);
    }

    private setBoard1(): void {

        // los peones
        for (let i: number = 0; i < 8; i++) {
            // los peones negros
            let pawn: Piece = new Piece(this.game, GameConstants.BLACK_PAWN, null);
            pawn.x = GameConstants.SQUARE_WIDTH * (i - 3.5);
            pawn.y = - 2.5 * GameConstants.SQUARE_WIDTH;
            this.add(pawn);

            // los blancos
            pawn = new Piece(this.game, GameConstants.WHITE_PAWN, null);
            pawn.x = GameConstants.SQUARE_WIDTH * (i - 3.5);
            pawn.y = 2.5 * GameConstants.SQUARE_WIDTH;
            this.add(pawn);
        }

        // las torres
        let rook: Piece = new Piece(this.game, GameConstants.BLACK_ROOK, null);
        rook.x = - 3.5 * GameConstants.SQUARE_WIDTH;
        rook.y = - 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(rook);

        rook = new Piece(this.game, GameConstants.BLACK_ROOK, null);
        rook.x = 3.5 * GameConstants.SQUARE_WIDTH;
        rook.y = - 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(rook);

        rook = new Piece(this.game, GameConstants.WHITE_ROOK, null);
        rook.x = - 3.5 * GameConstants.SQUARE_WIDTH;
        rook.y = 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(rook);

        rook = new Piece(this.game, GameConstants.WHITE_ROOK, null);
        rook.x = 3.5 * GameConstants.SQUARE_WIDTH;
        rook.y = 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(rook);

        // los caballos
        let knight: Piece = new Piece(this.game, GameConstants.BLACK_KNIGHT, null);
        knight.x = - 2.5 * GameConstants.SQUARE_WIDTH;
        knight.y = - 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(knight);

        knight = new Piece(this.game, GameConstants.BLACK_KNIGHT, null);
        knight.x = 2.5 * GameConstants.SQUARE_WIDTH;
        knight.y = - 3.5 * GameConstants.SQUARE_WIDTH;
        knight.scale.x = -1;
        this.add(knight);

        knight = new Piece(this.game, GameConstants.WHITE_KNIGHT, null);
        knight.x = - 2.5 * GameConstants.SQUARE_WIDTH;
        knight.y = 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(knight);

        knight = new Piece(this.game, GameConstants.WHITE_KNIGHT, null);
        knight.x = 2.5 * GameConstants.SQUARE_WIDTH;
        knight.y = 3.5 * GameConstants.SQUARE_WIDTH;
        knight.scale.x = -1;
        this.add(knight);

        // las alfiles
        let bishop: Piece = new Piece(this.game, GameConstants.BLACK_BISHOP, null);
        bishop.x = - 1.5 * GameConstants.SQUARE_WIDTH;
        bishop.y = - 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(bishop);

        bishop = new Piece(this.game, GameConstants.BLACK_BISHOP, null);
        bishop.x = 1.5 * GameConstants.SQUARE_WIDTH;
        bishop.y = - 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(bishop);

        bishop = new Piece(this.game, GameConstants.WHITE_BISHOP, null);
        bishop.x = - 1.5 * GameConstants.SQUARE_WIDTH;
        bishop.y = 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(bishop);

        bishop = new Piece(this.game, GameConstants.WHITE_BISHOP, null);
        bishop.x = 1.5 * GameConstants.SQUARE_WIDTH;
        bishop.y = 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(bishop);

        let queen: Piece = new Piece(this.game, GameConstants.BLACK_QUEEN, null);
        queen.x = -.5 * GameConstants.SQUARE_WIDTH;
        queen.y = -3.5 * GameConstants.SQUARE_WIDTH;
        this.add(queen);

        queen = new Piece(this.game, GameConstants.WHITE_QUEEN, null);
        queen.x = -.5 * GameConstants.SQUARE_WIDTH;
        queen.y = 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(queen);

        let king: Piece = new Piece(this.game, GameConstants.BLACK_KING, null);
        king.x = .5 * GameConstants.SQUARE_WIDTH;
        king.y = -3.5 * GameConstants.SQUARE_WIDTH;
        this.add(king);

        king = new Piece(this.game, GameConstants.WHITE_KING, null);
        king.x = .5 * GameConstants.SQUARE_WIDTH;
        king.y = 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(king);
    }

    private setBoard2(): void {

        this.movementPawnBishop = new Piece(this.game, GameConstants.BLACK_BISHOP, null);
        this.movementPawnBishop.x = -.5 * GameConstants.SQUARE_WIDTH;
        this.movementPawnBishop.y = 1.5 * GameConstants.SQUARE_WIDTH;
        this.add(this.movementPawnBishop);

        this.movementPawnRook = new Piece(this.game, GameConstants.BLACK_ROOK, null);
        this.movementPawnRook.x = 3.5 * GameConstants.SQUARE_WIDTH;
        this.movementPawnRook.y = 1.5 * GameConstants.SQUARE_WIDTH;
        this.add(this.movementPawnRook);

        this.movementPawn1 = new Piece(this.game, GameConstants.WHITE_PAWN, null);
        this.movementPawn1.x = -3.5 * GameConstants.SQUARE_WIDTH;
        this.movementPawn1.y = 2.5 * GameConstants.SQUARE_WIDTH;
        this.add(this.movementPawn1);

        this.movementPawn2 = new Piece(this.game, GameConstants.WHITE_PAWN, null);
        this.movementPawn2.x = -1.5 * GameConstants.SQUARE_WIDTH;
        this.movementPawn2.y = 2.5 * GameConstants.SQUARE_WIDTH;
        this.add(this.movementPawn2);

        this.movementPawn3 = new Piece(this.game, GameConstants.WHITE_PAWN, null);
        this.movementPawn3.x = .5 * GameConstants.SQUARE_WIDTH;
        this.movementPawn3.y = 2.5 * GameConstants.SQUARE_WIDTH;
        this.add(this.movementPawn3);

        this.movementPawn4 = new Piece(this.game, GameConstants.WHITE_PAWN, null);
        this.movementPawn4.x = 2.5 * GameConstants.SQUARE_WIDTH;
        this.movementPawn4.y = 2.5 * GameConstants.SQUARE_WIDTH;
        this.add(this.movementPawn4);

        this.animateMovementPawn1();
    }

    private setBoard3(): void {

        this.promotionPawn1 = new Piece(this.game, GameConstants.WHITE_PAWN, null);
        this.promotionPawn1.x = -1.5 * GameConstants.SQUARE_WIDTH;
        this.promotionPawn1.y = -2.5 * GameConstants.SQUARE_WIDTH;
        this.add(this.promotionPawn1);

        this.promotionPawn2 = new Piece(this.game, GameConstants.WHITE_PAWN, null);
        this.promotionPawn2.x = -.5 * GameConstants.SQUARE_WIDTH;
        this.promotionPawn2.y = -2.5 * GameConstants.SQUARE_WIDTH;
        this.add(this.promotionPawn2);

        this.promotionPawn3 = new Piece(this.game, GameConstants.WHITE_PAWN, null);
        this.promotionPawn3.x = .5 * GameConstants.SQUARE_WIDTH;
        this.promotionPawn3.y = -2.5 * GameConstants.SQUARE_WIDTH;
        this.add(this.promotionPawn3);

        this.promotionPawn4 = new Piece(this.game, GameConstants.WHITE_PAWN, null);
        this.promotionPawn4.x = 1.5 * GameConstants.SQUARE_WIDTH;
        this.promotionPawn4.y = -2.5 * GameConstants.SQUARE_WIDTH;
        this.add(this.promotionPawn4);

        this.promotionRook = new Piece(this.game, GameConstants.WHITE_ROOK, null);
        this.promotionRook.x = -1.5 * GameConstants.SQUARE_WIDTH;
        this.promotionRook.y = -3.5 * GameConstants.SQUARE_WIDTH;
        this.promotionRook.visible = false;
        this.add(this.promotionRook);

        this.promotionKnight = new Piece(this.game, GameConstants.WHITE_KNIGHT, null);
        this.promotionKnight.x = -.5 * GameConstants.SQUARE_WIDTH;
        this.promotionKnight.y = -3.5 * GameConstants.SQUARE_WIDTH;
        this.promotionKnight.visible = false;
        this.promotionKnight.alpha = 0;
        this.add(this.promotionKnight);

        this.promotionBishop = new Piece(this.game, GameConstants.WHITE_BISHOP, null);
        this.promotionBishop.x = .5 * GameConstants.SQUARE_WIDTH;
        this.promotionBishop.y = -3.5 * GameConstants.SQUARE_WIDTH;
        this.promotionBishop.visible = false;
        this.promotionBishop.alpha = 0;
        this.add(this.promotionBishop);

        this.promotionQueen = new Piece(this.game, GameConstants.WHITE_QUEEN, null);
        this.promotionQueen.x = 1.5 * GameConstants.SQUARE_WIDTH;
        this.promotionQueen.y = -3.5 * GameConstants.SQUARE_WIDTH;
        this.promotionQueen.visible = false;
        this.promotionQueen.alpha = 0;
        this.add(this.promotionQueen);

        this.animatePromotedPawn1();
    }

    private setBoard4(): void {

        this.line.visible = true;
        this.line.x = -.5 * GameConstants.SQUARE_WIDTH;
        this.line.y = 1.5 * GameConstants.SQUARE_WIDTH;
        this.line.scale.x = 0;

        this.lineCap.visible = true;
        this.lineCap.x = -.5 * GameConstants.SQUARE_WIDTH;
        this.lineCap.y = 1.5 * GameConstants.SQUARE_WIDTH;

        this.rook = new Piece(this.game, GameConstants.WHITE_ROOK, null);
        this.rook.x = -.5 * GameConstants.SQUARE_WIDTH;
        this.rook.y = 1.5 * GameConstants.SQUARE_WIDTH;
        this.add(this.rook);

        this.animateRook();
    }

    private setBoard5(): void {

        this.marker = new Phaser.Sprite(this.game, 0, 0, "texture_atlas_1", "marker.png");
        this.marker.anchor.set(.5);
        this.add(this.marker);

        this.knight = new Piece(this.game, GameConstants.WHITE_KNIGHT, null);
        this.knight.x = .5 * GameConstants.SQUARE_WIDTH;
        this.knight.y = .5 * GameConstants.SQUARE_WIDTH;
        this.add(this.knight);

        this.animateKnigt();
    }

    private setBoard6(): void {

        this.line.visible = true;
        this.line.x = -.5 * GameConstants.SQUARE_WIDTH;
        this.line.y = 1.5 * GameConstants.SQUARE_WIDTH;
        this.line.scale.x = 0;

        this.lineCap.visible = true;
        this.lineCap.x = -.5 * GameConstants.SQUARE_WIDTH;
        this.lineCap.y = 1.5 * GameConstants.SQUARE_WIDTH;

        this.bishop = new Piece(this.game, GameConstants.WHITE_BISHOP, null);
        this.bishop.x = -.5 * GameConstants.SQUARE_WIDTH;
        this.bishop.y = 1.5 * GameConstants.SQUARE_WIDTH;
        this.add(this.bishop);

        this.animateBishop();
    }

    private setBoard7(): void {

        this.line.visible = true;
        this.line.x = -.5 * GameConstants.SQUARE_WIDTH;
        this.line.y = 1.5 * GameConstants.SQUARE_WIDTH;
        this.line.scale.x = 0;

        this.lineCap.visible = true;
        this.lineCap.x = -.5 * GameConstants.SQUARE_WIDTH;
        this.lineCap.y = 1.5 * GameConstants.SQUARE_WIDTH;

        this.queen = new Piece(this.game, GameConstants.WHITE_QUEEN, null);
        this.queen.x = -.5 * GameConstants.SQUARE_WIDTH;
        this.queen.y = 1.5 * GameConstants.SQUARE_WIDTH;
        this.add(this.queen);

        this.animateQueen();
    }

    private setBoard8(): void {
        
        this.king = new Piece(this.game, GameConstants.WHITE_KING, null);
        this.king.x = -.5 * GameConstants.SQUARE_WIDTH;
        this.king.y = .5 * GameConstants.SQUARE_WIDTH;
        this.add(this.king);

        let bishop: Piece = new Piece(this.game, GameConstants.BLACK_BISHOP, null);
        bishop.x = -.5 * GameConstants.SQUARE_WIDTH;
        bishop.y = -1.5 * GameConstants.SQUARE_WIDTH;
        this.add(bishop);

        let forbiddenMoveImage: Phaser.Image = new Phaser.Image(this.game, -1.5 * GameConstants.SQUARE_WIDTH, -.5 * GameConstants.SQUARE_WIDTH, "texture_atlas_1", "forbidden-move.png");
        forbiddenMoveImage.anchor.set(.5);
        this.add(forbiddenMoveImage);

        forbiddenMoveImage = new Phaser.Image(this.game, .5 * GameConstants.SQUARE_WIDTH, -.5 * GameConstants.SQUARE_WIDTH, "texture_atlas_1", "forbidden-move.png");
        forbiddenMoveImage.anchor.set(.5);
        this.add(forbiddenMoveImage);

        this.animateKing();
    }

    private setBoard9(): void {

        // el rey
        this.king = new Piece(this.game, GameConstants.WHITE_KING, null);
        this.king.x = .5 * GameConstants.SQUARE_WIDTH;
        this.king.y = 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(this.king);

        // las torres
        this.rightRook = new Piece(this.game, GameConstants.WHITE_ROOK, null);
        this.rightRook.x = 3.5 * GameConstants.SQUARE_WIDTH;
        this.rightRook.y = 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(this.rightRook);

        this.leftRook = new Piece(this.game, GameConstants.WHITE_ROOK, null);
        this.leftRook.x = - 3.5 * GameConstants.SQUARE_WIDTH;
        this.leftRook.y = 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(this.leftRook);

        this.animateCastlingRightSide();
    }

    private setBoard10(): void {
        
        this.setBoard1();
    
        let otherBlackPawn: Piece;

        for (let i: number = 0; i < this.length; i++) {
            
            let piece: any = this.getChildAt(i);

            if (piece.x === -2.5 * GameConstants.SQUARE_WIDTH && piece.y === 2.5 * GameConstants.SQUARE_WIDTH) {
                this.enPassantPawnWhite = piece;
            }

            if (piece.x === -1.5 * GameConstants.SQUARE_WIDTH && piece.y === -2.5 * GameConstants.SQUARE_WIDTH) {
                this.enPassantPawnBlack = piece;
            }

            if (piece.x === 3.5 * GameConstants.SQUARE_WIDTH && piece.y === -2.5 * GameConstants.SQUARE_WIDTH) {
                otherBlackPawn = piece;
            }
        }

        this.bringToTop(this.enPassantPawnWhite);

        otherBlackPawn.y = -.5 * GameConstants.SQUARE_WIDTH;

        this.animateEnPassant();
    }

    private setBoard11(): void {

        // la flecha de la reina
        const threateningArrow: Phaser.Image = new Phaser.Image(this.game, 3.5 * GameConstants.SQUARE_WIDTH, .5 * GameConstants.SQUARE_WIDTH, "texture_atlas_1", "instructions-arrow.png");
        threateningArrow.anchor.y = .5;
        threateningArrow.angle = 135;
        this.add(threateningArrow);

        this.game.add.tween(threateningArrow.scale)
            .to({x: .85, y: .85}, 550, Phaser.Easing.Cubic.Out, true, 0, -1, true);
            
        // los peones
        let pawn: Piece;

        for (let i: number = 0; i < 8; i++) {

            if (i !== 4) {
                pawn = new Piece(this.game, GameConstants.BLACK_PAWN, null);
                pawn.x = GameConstants.SQUARE_WIDTH * (i - 3.5);
                pawn.y = - 2.5 * GameConstants.SQUARE_WIDTH;
                this.add(pawn);
            }

            if (i < 4 || i > 5) {
                pawn = new Piece(this.game, GameConstants.WHITE_PAWN, null);
                pawn.x = GameConstants.SQUARE_WIDTH * (i - 3.5);
                pawn.y = 2.5 * GameConstants.SQUARE_WIDTH;
                this.add(pawn);
            }
        }

        pawn = new Piece(this.game, GameConstants.BLACK_PAWN, null);
        pawn.x = .5 * GameConstants.SQUARE_WIDTH;
        pawn.y = -1.5 * GameConstants.SQUARE_WIDTH;
        this.add(pawn);

        pawn = new Piece(this.game, GameConstants.WHITE_PAWN, null);
        pawn.x = .5 * GameConstants.SQUARE_WIDTH;
        pawn.y = 1.5 * GameConstants.SQUARE_WIDTH;
        this.add(pawn);

        pawn = new Piece(this.game, GameConstants.WHITE_PAWN, null);
        pawn.x = 1.5 * GameConstants.SQUARE_WIDTH;
        pawn.y = 1.5 * GameConstants.SQUARE_WIDTH;
        this.add(pawn);

        // las torres
        let rook: Piece = new Piece(this.game, GameConstants.BLACK_ROOK, null);
        rook.x = - 3.5 * GameConstants.SQUARE_WIDTH;
        rook.y = - 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(rook);

        rook = new Piece(this.game, GameConstants.BLACK_ROOK, null);
        rook.x = 3.5 * GameConstants.SQUARE_WIDTH;
        rook.y = - 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(rook);

        rook = new Piece(this.game, GameConstants.WHITE_ROOK, null);
        rook.x = - 3.5 * GameConstants.SQUARE_WIDTH;
        rook.y = 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(rook);

        rook = new Piece(this.game, GameConstants.WHITE_ROOK, null);
        rook.x = 3.5 * GameConstants.SQUARE_WIDTH;
        rook.y = 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(rook);

        // los caballos
        let knight = new Piece(this.game, GameConstants.BLACK_KNIGHT, null);
        knight.x = - 2.5 * GameConstants.SQUARE_WIDTH;
        knight.y = - 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(knight);

        knight = new Piece(this.game, GameConstants.BLACK_KNIGHT, null);
        knight.x = 2.5 * GameConstants.SQUARE_WIDTH;
        knight.y = - 3.5 * GameConstants.SQUARE_WIDTH;
        knight.scale.x = -1;
        this.add(knight);

        knight = new Piece(this.game, GameConstants.WHITE_KNIGHT, null);
        knight.x = - 2.5 * GameConstants.SQUARE_WIDTH;
        knight.y = 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(knight);

        knight = new Piece(this.game, GameConstants.WHITE_KNIGHT, null);
        knight.x = 2.5 * GameConstants.SQUARE_WIDTH;
        knight.y = 3.5 * GameConstants.SQUARE_WIDTH;
        knight.scale.x = -1;
        this.add(knight);

        // las alfiles
        let bishop: Piece = new Piece(this.game, GameConstants.BLACK_BISHOP, null);
        bishop.x = - 1.5 * GameConstants.SQUARE_WIDTH;
        bishop.y = - 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(bishop);

        bishop = new Piece(this.game, GameConstants.BLACK_BISHOP, null);
        bishop.x = 1.5 * GameConstants.SQUARE_WIDTH;
        bishop.y = - 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(bishop);

        bishop = new Piece(this.game, GameConstants.WHITE_BISHOP, null);
        bishop.x = - 1.5 * GameConstants.SQUARE_WIDTH;
        bishop.y = 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(bishop);

        bishop = new Piece(this.game, GameConstants.WHITE_BISHOP, null);
        bishop.x = 1.5 * GameConstants.SQUARE_WIDTH;
        bishop.y = 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(bishop);

        let queen = new Piece(this.game, GameConstants.BLACK_QUEEN, null);
        queen.x = 3.5 * GameConstants.SQUARE_WIDTH;
        queen.y = .5 * GameConstants.SQUARE_WIDTH;
        this.add(queen);

        queen = new Piece(this.game, GameConstants.WHITE_QUEEN, null);
        queen.x = -.5 * GameConstants.SQUARE_WIDTH;
        queen.y = 3.5 * GameConstants.SQUARE_WIDTH;
        this.add(queen);

        let king = new Piece(this.game, GameConstants.BLACK_KING, null);
        king.x = .5 * GameConstants.SQUARE_WIDTH;
        king.y = -3.5 * GameConstants.SQUARE_WIDTH;
        this.add(king);

        // animarlo
        king = new Piece(this.game, GameConstants.WHITE_KING, null);
        king.x = .5 * GameConstants.SQUARE_WIDTH;
        king.y = 3.5 * GameConstants.SQUARE_WIDTH;
        king.check();
        this.add(king);
    }

    private setBoard12(): void {

        let bishop = new Piece(this.game, GameConstants.BLACK_BISHOP, null);
        bishop.x = -.5 * GameConstants.SQUARE_WIDTH;
        bishop.y = -2.5 * GameConstants.SQUARE_WIDTH;
        this.add(bishop);

        let pawn = new Piece(this.game, GameConstants.BLACK_PAWN, null);
        pawn.x = -3.5 * GameConstants.SQUARE_WIDTH;
        pawn.y = -1.5 * GameConstants.SQUARE_WIDTH;
        this.add(pawn);

        let queen = new Piece(this.game, GameConstants.WHITE_QUEEN, null);
        queen.x = -2.5 * GameConstants.SQUARE_WIDTH;
        queen.y = .5 * GameConstants.SQUARE_WIDTH;
        this.add(queen);

        let knight = new Piece(this.game, GameConstants.WHITE_KNIGHT, null);
        knight.x = -1.5 * GameConstants.SQUARE_WIDTH;
        knight.y = 2.5 * GameConstants.SQUARE_WIDTH;
        this.add(knight);

        let king = new Piece(this.game, GameConstants.BLACK_KING, null);
        king.x = -3.5 * GameConstants.SQUARE_WIDTH;
        king.y = -.5 * GameConstants.SQUARE_WIDTH;
        king.check();
        this.add(king);

        king = new Piece(this.game, GameConstants.WHITE_KING, null);
        king.x = .5 * GameConstants.SQUARE_WIDTH;
        king.y = 2.5 * GameConstants.SQUARE_WIDTH;
        this.add(king);
    }

    private setBoard13(): void {

        let king = new Piece(this.game, GameConstants.BLACK_KING, null);
        king.x = .5 * GameConstants.SQUARE_WIDTH;
        king.y = -3.5 * GameConstants.SQUARE_WIDTH;
        this.add(king);

        king = new Piece(this.game, GameConstants.WHITE_KING, null);
        king.x = 3.5 * GameConstants.SQUARE_WIDTH;
        king.y = .5 * GameConstants.SQUARE_WIDTH;
        this.add(king);

        let queen = new Piece(this.game, GameConstants.BLACK_QUEEN, null);
        queen.x = 2.5 * GameConstants.SQUARE_WIDTH;
        queen.y = -1.5 * GameConstants.SQUARE_WIDTH;
        this.add(queen);

        let pawn = new Piece(this.game, GameConstants.BLACK_PAWN, null);
        pawn.x = 3.5 * GameConstants.SQUARE_WIDTH;
        pawn.y = -.5 * GameConstants.SQUARE_WIDTH;
        this.add(pawn);

        pawn = new Piece(this.game, GameConstants.WHITE_PAWN, null);
        pawn.x = 3.5 * GameConstants.SQUARE_WIDTH;
        pawn.y = 1.5 * GameConstants.SQUARE_WIDTH;
        this.add(pawn);
    }

    private animateMovementPawn1(): void {

        if (!this.game) {
            return;
        }

        this.game.add.tween(this.movementPawn1)
            .to({y: .5 * GameConstants.SQUARE_WIDTH}, 600, Phaser.Easing.Cubic.Out, true, 400)
            .onComplete.add( this.animateMovementPawn2, this);
    }

    private animateMovementPawn2(): void {

        if (!this.game) {
            return;
        }

        this.game.add.tween(this.movementPawn2)
            .to({y: 1.5 * GameConstants.SQUARE_WIDTH}, 400, Phaser.Easing.Cubic.Out, true, 400)
            .onComplete.add( this.animateMovementPawn3, this);
    }

    private animateMovementPawn3(): void {

        if (!this.game) {
            return;
        }

        this.movementPawn3.pieceSprite.angle = -12;
        this.movementPawn3.pieceSprite.x = 15;

        this.game.add.tween(this.movementPawn3)
            .to({x: -.5 * GameConstants.SQUARE_WIDTH, y: 1.5 * GameConstants.SQUARE_WIDTH}, 250, Phaser.Easing.Cubic.Out, true, 400)
            .onComplete.add(function(): void {

                if (!this.game) {
                    return;
                }

                // aqui empieza a desaparecer el alfil
                this.movementPawnBishop.flash();
                this.game.add.tween(this.movementPawnBishop)
                    .to({alpha: 0}, 300, Phaser.Easing.Cubic.Out, true, 200);

                this.game.add.tween(this.movementPawn3.pieceSprite)
                    .to({x: 0, angle: 0}, 300, Phaser.Easing.Bounce.Out, true)
                    .onComplete.add(this.animateMovementPawn4, this);
                }, this);
    }

    private animateMovementPawn4(): void {

        if (!this.game) {
            return;
        }

        this.movementPawn4.pieceSprite.angle = 12;
        this.movementPawn4.pieceSprite.x = -15;

        this.game.add.tween(this.movementPawn4)
            .to({x: 3.5 * GameConstants.SQUARE_WIDTH, y: 1.5 * GameConstants.SQUARE_WIDTH}, 250, Phaser.Easing.Cubic.Out, true, 400)
            .onComplete.add(function(): void {

                if (!this.game) {
                    return;
                }

                // aqui empieza a desaparecer la torre
                this.movementPawnRook.flash();
                this.game.add.tween(this.movementPawnRook)
                    .to({alpha: 0}, 300, Phaser.Easing.Cubic.Out, true, 200);

                this.game.add.tween(this.movementPawn4.pieceSprite)
                    .to({x: 0, angle: 0}, 300, Phaser.Easing.Bounce.Out, true)
                    .onComplete.add(function(): void {

                        if (!this.game) {
                            return;
                        }

                        this.game.add.tween(this.movementPawn1)
                                .to({alpha: 0}, 300, Phaser.Easing.Cubic.Out, true, 300);
                        this.game.add.tween(this.movementPawn2)
                                .to({alpha: 0}, 300, Phaser.Easing.Cubic.Out, true, 400);
                        this.game.add.tween(this.movementPawn3)
                                .to({alpha: 0}, 300, Phaser.Easing.Cubic.Out, true, 500);
                        this.game.add.tween(this.movementPawn4)
                                .to({alpha: 0}, 300, Phaser.Easing.Cubic.Out, true, 600);


                        this.game.time.events.add( 1000, this.resetPositionsMovementPawn, this);

                    }, this);
                }, this);
    }

    private resetPositionsMovementPawn(): void {

        if (!this.game) {
            return;
        }

        this.game.add.tween(this.movementPawnBishop)
            .to({alpha: 1}, 300, Phaser.Easing.Cubic.Out, true);

        this.game.add.tween(this.movementPawnRook)
            .to({alpha: 1}, 300, Phaser.Easing.Cubic.Out, true);

        this.movementPawn1.x = -3.5 * GameConstants.SQUARE_WIDTH;
        this.movementPawn1.y = 2.5 * GameConstants.SQUARE_WIDTH;

        this.movementPawn2.x = -1.5 * GameConstants.SQUARE_WIDTH;
        this.movementPawn2.y = 2.5 * GameConstants.SQUARE_WIDTH;

        this.movementPawn3.x = .5 * GameConstants.SQUARE_WIDTH;
        this.movementPawn3.y = 2.5 * GameConstants.SQUARE_WIDTH;

        this.movementPawn4.x = 2.5 * GameConstants.SQUARE_WIDTH;
        this.movementPawn4.y = 2.5 * GameConstants.SQUARE_WIDTH;

        this.game.add.tween(this.movementPawn1)
            .to({alpha: 1}, 300, Phaser.Easing.Cubic.Out, true, 600);

        this.game.add.tween(this.movementPawn2)
            .to({alpha: 1}, 300, Phaser.Easing.Cubic.Out, true, 500);

        this.game.add.tween(this.movementPawn3)
            .to({alpha: 1}, 300, Phaser.Easing.Cubic.Out, true, 400);

        this.game.add.tween(this.movementPawn4)
            .to({alpha: 1}, 300, Phaser.Easing.Cubic.Out, true, 300)
            .onComplete.add(this.animateMovementPawn1, this);
    }

    private animatePromotedPawn1(): void {

        if (!this.game) {
            return;
        }

        this.game.add.tween(this.promotionPawn1)
            .to({y: -3.5 * GameConstants.SQUARE_WIDTH}, 400, Phaser.Easing.Cubic.Out, true, 400)
            .onComplete.add(function(): void {

                if (!this.game) {
                    return;
                }

                this.promotionPawn1.flash();

                this.game.add.tween(this.promotionPawn1)
                    .to({alpha: 0}, 250, Phaser.Easing.Cubic.Out, true, 150);

                this.promotionRook.visible = true;
                this.game.add.tween(this.promotionRook)
                    .to({alpha: 1}, 250, Phaser.Easing.Cubic.Out, true, 150)
                    .onComplete.add(function(): void {
                        this.animatePromotedPawn2();
                    }, this);

            }, this);
    }

        private animatePromotedPawn2(): void {

        if (!this.game) {
            return;
        }

        this.game.add.tween(this.promotionPawn2)
            .to({y: -3.5 * GameConstants.SQUARE_WIDTH}, 400, Phaser.Easing.Cubic.Out, true, 400)
            .onComplete.add(function(): void {

                if (!this.game) {
                    return;
                }

                this.promotionPawn2.flash();

                this.game.add.tween(this.promotionPawn2)
                    .to({alpha: 0}, 250, Phaser.Easing.Cubic.Out, true, 150);

                this.promotionKnight.visible = true;
                this.game.add.tween(this.promotionKnight)
                    .to({alpha: 1}, 250, Phaser.Easing.Cubic.Out, true, 150)
                    .onComplete.add(function(): void {
                        this.animatePromotedPawn3();
                    }, this);

            }, this);
    }

    private animatePromotedPawn3(): void {

        if (!this.game) {
            return;
        }

        this.game.add.tween(this.promotionPawn3)
            .to({y: -3.5 * GameConstants.SQUARE_WIDTH}, 400, Phaser.Easing.Cubic.Out, true, 400)
            .onComplete.add(function(): void {

                if (!this.game) {
                    return;
                }

                this.promotionPawn3.flash();

                this.game.add.tween(this.promotionPawn3)
                    .to({alpha: 0}, 250, Phaser.Easing.Cubic.Out, true, 150);

                this.promotionBishop.visible = true;
                this.game.add.tween(this.promotionBishop)
                    .to({alpha: 1}, 250, Phaser.Easing.Cubic.Out, true, 150)
                    .onComplete.add(function(): void {
                        this.animatePromotedPawn4();
                    }, this);

            }, this);
    }

        private animatePromotedPawn4(): void {

        if (!this.game) {
            return;
        }

        this.game.add.tween(this.promotionPawn4)
            .to({y: -3.5 * GameConstants.SQUARE_WIDTH}, 400, Phaser.Easing.Cubic.Out, true, 400)
            .onComplete.add(function(): void {

                if (!this.game) {
                    return;
                }

                this.promotionPawn4.flash();

                this.game.add.tween(this.promotionPawn4)
                    .to({alpha: 0}, 250, Phaser.Easing.Cubic.Out, true, 150);

                this.promotionQueen.visible = true;
                this.game.add.tween(this.promotionQueen)
                    .to({alpha: 1}, 250, Phaser.Easing.Cubic.Out, true, 150)
                    .onComplete.add(function(): void {
                        this.resetPromotedPieces();
                    }, this);

            }, this);
    }

    private resetPromotedPieces(): void {

        if (!this.game) {
            return;
        }

        this.game.add.tween(this.promotionRook)
            .to({alpha: 0}, 250, Phaser.Easing.Cubic.Out, true, 1000);
        this.game.add.tween(this.promotionKnight)
            .to({alpha: 0}, 250, Phaser.Easing.Cubic.Out, true, 1000);
        this.game.add.tween(this.promotionBishop)
            .to({alpha: 0}, 250, Phaser.Easing.Cubic.Out, true, 1000);
        this.game.add.tween(this.promotionQueen)
            .to({alpha: 0}, 250, Phaser.Easing.Cubic.Out, true, 1000)
            .onComplete.add(function(): void {
                this.promotionRook.visible = false;
                this.promotionKnight.visible = false;
                this.promotionBishop.visible = false;
                this.promotionQueen.visible = false;
            }, this);

        this.promotionPawn1.y = -2.5 * GameConstants.SQUARE_WIDTH;
        this.promotionPawn2.y = -2.5 * GameConstants.SQUARE_WIDTH;
        this.promotionPawn3.y = -2.5 * GameConstants.SQUARE_WIDTH;
        this.promotionPawn4.y = -2.5 * GameConstants.SQUARE_WIDTH;

        this.game.add.tween(this.promotionPawn1)
            .to({alpha: 1}, 250, Phaser.Easing.Cubic.Out, true, 1300);
        this.game.add.tween(this.promotionPawn2)
            .to({alpha: 1}, 250, Phaser.Easing.Cubic.Out, true, 1300);
        this.game.add.tween(this.promotionPawn3)
            .to({alpha: 1}, 250, Phaser.Easing.Cubic.Out, true, 1300);
        this.game.add.tween(this.promotionPawn4)
            .to({alpha: 1}, 250, Phaser.Easing.Cubic.Out, true, 1300)
            .onComplete.add(this.animatePromotedPawn1, this);
    }

    private animateRook(): void {

        if (!this.game) {
            return;
        }

        this.line.angle = -90;
        this.game.add.tween(this.line.scale)
            .to({x: 5}, 1000, Phaser.Easing.Cubic.Out, true, 200, 0, true);
        this.lineCap.angle = -90;

        this.game.add.tween(this.rook)
            .to({y: -3.5 * GameConstants.SQUARE_WIDTH}, 1000, Phaser.Easing.Cubic.Out, true, 200, 0, true)
            .onComplete.add(function(): void {

                if (!this.game) {
                    return;
                }

                this.line.angle = 0;
                this.game.add.tween(this.line.scale)
                    .to({x: 4}, 900, Phaser.Easing.Cubic.Out, true, 400, 0, true);
                this.lineCap.angle = 0;

                this.game.add.tween(this.rook)
                    .to({x: 3.5 * GameConstants.SQUARE_WIDTH}, 900, Phaser.Easing.Cubic.Out, true, 400, 0, true)
                    .onComplete.add(function(): void {
                        if (!this.game) {
                            return;
                        }

                        this.line.angle = 90;
                        this.game.add.tween(this.line.scale)
                            .to({x: 2}, 600, Phaser.Easing.Cubic.Out, true, 400, 0, true);
                        this.lineCap.angle = 90;

                        this.game.add.tween(this.rook)
                            .to({y: 3.5 * GameConstants.SQUARE_WIDTH}, 600, Phaser.Easing.Cubic.Out, true, 400, 0, true)
                            .onComplete.add(function(): void {
                                if (!this.game) {
                                    return;
                                }

                                this.line.angle = 180;
                                this.game.add.tween(this.line.scale)
                                    .to({x: 3}, 700, Phaser.Easing.Cubic.Out, true, 400, 0, true);
                                this.lineCap.angle = 180;

                                this.game.add.tween(this.rook)
                                    .to({x: -3.5 * GameConstants.SQUARE_WIDTH}, 700, Phaser.Easing.Cubic.Out, true, 400, 0, true)
                                    .onComplete.add(this.animateRook, this);
                                }, this);
                        }, this);
            }, this);
    }

    private animateBishop(): void {

        if (!this.game) {
            return;
        }

        this.line.angle = -45;
        this.game.add.tween(this.line.scale)
            .to({x: 4 * Math.SQRT2}, 1000, Phaser.Easing.Cubic.Out, true, 200, 0, true);
        this.lineCap.angle = -45;

        this.game.add.tween(this.bishop)
            .to({x: 3.5 * GameConstants.SQUARE_WIDTH, y: -2.5 * GameConstants.SQUARE_WIDTH}, 1000, Phaser.Easing.Cubic.Out, true, 200, 0, true)
            .onComplete.add(function(): void {

                if (!this.game) {
                    return;
                }

                this.line.angle = 45;
                this.game.add.tween(this.line.scale)
                    .to({x: 2 * Math.SQRT2}, 700, Phaser.Easing.Cubic.Out, true, 400, 0, true);
                this.lineCap.angle = 45;

                this.game.add.tween(this.bishop)
                    .to({x: 1.5 * GameConstants.SQUARE_WIDTH, y: 3.5 * GameConstants.SQUARE_WIDTH}, 700, Phaser.Easing.Cubic.Out, true, 400, 0, true)
                    .onComplete.add(function(): void {
                        if (!this.game) {
                            return;
                        }

                        this.line.angle = 135;
                        this.game.add.tween(this.line.scale)
                            .to({x: 2 * Math.SQRT2}, 600, Phaser.Easing.Cubic.Out, true, 400, 0, true);
                        this.lineCap.angle = 135;

                        this.game.add.tween(this.bishop)
                            .to({x: -2.5 * GameConstants.SQUARE_WIDTH, y: 3.5 * GameConstants.SQUARE_WIDTH}, 600, Phaser.Easing.Cubic.Out, true, 400, 0, true)
                            .onComplete.add(function(): void {

                                if (!this.game) {
                                    return;
                                }

                                this.line.angle = 225;
                                this.game.add.tween(this.line.scale)
                                    .to({x: 3 * Math.SQRT2}, 800, Phaser.Easing.Cubic.Out, true, 400, 0, true);
                                this.lineCap.angle = 225;

                                this.game.add.tween(this.bishop)
                                    .to({x: -3.5 * GameConstants.SQUARE_WIDTH, y: -1.5 * GameConstants.SQUARE_WIDTH}, 800, Phaser.Easing.Cubic.Out, true, 400, 0, true)
                                    .onComplete.add(this.animateBishop, this);
                                }, this);
                        }, this);
            }, this);
    }

    private animateQueen(): void {

        if (!this.game) {
            return;
        }

        this.line.angle = -90;
        this.game.add.tween(this.line.scale)
            .to({x: 5}, 1000, Phaser.Easing.Cubic.Out, true, 200, 0, true);
        this.lineCap.angle = -90;
        
        // tween N
        this.game.add.tween(this.queen)
            .to({y: -3.5 * GameConstants.SQUARE_WIDTH}, 1000, Phaser.Easing.Cubic.Out, true, 200, 0, true)
            .onComplete.add(function(): void {

                if (!this.game) {
                    return;
                }

                this.line.angle = -45;
                this.game.add.tween(this.line.scale)
                    .to({x: 4 * Math.SQRT2}, 1000, Phaser.Easing.Cubic.Out, true, 400, 0, true);
                this.lineCap.angle = -45;

                // tween NE
                this.game.add.tween(this.queen)
                    .to({x: 3.5 * GameConstants.SQUARE_WIDTH, y: -2.5 * GameConstants.SQUARE_WIDTH}, 1000, Phaser.Easing.Cubic.Out, true, 400, 0, true)
                    .onComplete.add(function(): void {

                        if (!this.game) {
                            return;
                        }

                        this.line.angle = 0;
                        this.game.add.tween(this.line.scale)
                            .to({x: 3.5}, 600, Phaser.Easing.Cubic.Out, true, 800, 0, true);
                        this.lineCap.angle = 0;

                        // tween E
                        this.game.add.tween(this.queen)
                            .to({x: 3.5 * GameConstants.SQUARE_WIDTH}, 600, Phaser.Easing.Cubic.Out, true, 800, 0, true)
                            .onComplete.add(function(): void {

                                if (!this.game) {
                                    return;
                                }

                                this.line.angle = 45;
                                this.game.add.tween(this.line.scale)
                                    .to({x: 2 * Math.SQRT2}, 600, Phaser.Easing.Cubic.Out, true, 400, 0, true);
                                this.lineCap.angle = 45;

                                // tween SE
                                this.game.add.tween(this.queen)
                                    .to({x: 1.5 * GameConstants.SQUARE_WIDTH, y: 3.5 * GameConstants.SQUARE_WIDTH}, 600, Phaser.Easing.Cubic.Out, true, 400, 0, true)
                                    .onComplete.add(function(): void {

                                        if (!this.game) {
                                            return;
                                        }

                                        this.line.angle = 90;
                                        this.game.add.tween(this.line.scale)
                                            .to({x: 2 }, 400, Phaser.Easing.Cubic.Out, true, 500, 0, true);
                                        this.lineCap.angle = 90;

                                        // tween S
                                        this.game.add.tween(this.queen)
                                            .to({y: 3.5 * GameConstants.SQUARE_WIDTH}, 400, Phaser.Easing.Cubic.Out, true, 500, 0, true)
                                            .onComplete.add(function(): void {

                                                if (!this.game) {
                                                    return;
                                                }

                                                this.line.angle = 135;
                                                this.game.add.tween(this.line.scale)
                                                    .to({x: 2 * Math.SQRT2 }, 600, Phaser.Easing.Cubic.Out, true, 400, 0, true);
                                                this.lineCap.angle = 135;

                                                // tween SW
                                                this.game.add.tween(this.queen)
                                                    .to({x: -2.5 * GameConstants.SQUARE_WIDTH, y: 3.5 * GameConstants.SQUARE_WIDTH}, 600, Phaser.Easing.Cubic.Out, true, 400, 0, true)
                                                    .onComplete.add(function(): void {

                                                        if (!this.game) {
                                                            return;
                                                        }

                                                        this.line.angle = 180;
                                                        this.game.add.tween(this.line.scale)
                                                            .to({x: 3 }, 600, Phaser.Easing.Cubic.Out, true, 400, 0, true);
                                                        this.lineCap.angle = 180;

                                                        // tween W
                                                        this.game.add.tween(this.queen)
                                                            .to({x: -3.5 * GameConstants.SQUARE_WIDTH}, 600, Phaser.Easing.Cubic.Out, true, 400, 0, true)
                                                            .onComplete.add(function(): void {

                                                                if (!this.game) {
                                                                    return;
                                                                }

                                                                this.line.angle = -135;
                                                                this.game.add.tween(this.line.scale)
                                                                    .to({x: 3 * Math.SQRT2 }, 900, Phaser.Easing.Cubic.Out, true, 600, 0, true);
                                                                this.lineCap.angle = -135;

                                                                // tween NW
                                                                this.game.add.tween(this.queen)
                                                                    .to({x: -3.5 * GameConstants.SQUARE_WIDTH, y: -1.5 * GameConstants.SQUARE_WIDTH}, 900, Phaser.Easing.Cubic.Out, true, 600, 0, true)
                                                                    .onComplete.add(this.animateQueen, this);

                                                }, this);
                                            }, this);
                                        }, this);
                                    }, this);
                                }, this);
                        }, this);
            }, this);

    }

    private animateKing(): void {
        
        if (!this.game) {
            return;
        }

        // tween N
        this.game.add.tween(this.king)
            .to({y: -.5 * GameConstants.SQUARE_WIDTH}, 400, Phaser.Easing.Cubic.Out, true, 800, 0, true)
            .onComplete.add(function(): void {

                if (!this.game) {
                    return;
                }

                // tween E
                this.game.add.tween(this.king)
                    .to({x: .5 * GameConstants.SQUARE_WIDTH}, 400, Phaser.Easing.Cubic.Out, true, 400, 0, true)
                        .onComplete.add(function(): void {

                                if (!this.game) {
                                    return;
                                }

                                // tween SE
                                this.game.add.tween(this.king)
                                    .to({x: .5 * GameConstants.SQUARE_WIDTH, y: 1.5 * GameConstants.SQUARE_WIDTH}, 400, Phaser.Easing.Cubic.Out, true, 400, 0, true)
                                    .onComplete.add(function(): void {

                                        if (!this.game) {
                                            return;
                                        }

                                        // tween S
                                        this.game.add.tween(this.king)
                                            .to({y: 1.5 * GameConstants.SQUARE_WIDTH}, 400, Phaser.Easing.Cubic.Out, true, 400, 0, true)
                                            .onComplete.add(function(): void {

                                                if (!this.game) {
                                                    return;
                                                }

                                                // tween SW
                                                this.game.add.tween(this.king)
                                                    .to({x: -1.5 * GameConstants.SQUARE_WIDTH, y: 1.5 * GameConstants.SQUARE_WIDTH}, 400, Phaser.Easing.Cubic.Out, true, 400, 0, true)
                                                    .onComplete.add(function(): void {

                                                        if (!this.game) {
                                                            return;
                                                        }

                                                        // tween W
                                                        this.game.add.tween(this.king)
                                                            .to({x: -1.5 * GameConstants.SQUARE_WIDTH}, 400, Phaser.Easing.Cubic.Out, true, 400, 0, true)
                                                            .onComplete.add(this.animateKing, this);
                                            }, this);
                                        }, this);
                                    }, this);
                                }, this);
            }, this);
    }

    private animateCastlingRightSide(): void {

        if (!this.game) {
            return;
        }

        this.game.add.tween(this.king)
            .to({x: 2.5 * GameConstants.SQUARE_WIDTH}, 600, Phaser.Easing.Cubic.Out, true, 500)
            .onComplete.add(function(): void {

                if (!this.game) {
                    return;
                }

                this.game.add.tween(this.rightRook)
                    .to({x: 1.5 * GameConstants.SQUARE_WIDTH}, 400, Phaser.Easing.Cubic.Out, true, 500)
                    .onComplete.add(function(): void {

                            if (!this.game) {
                                return;
                            }

                                this.game.add.tween(this.king)
                                .to({alpha: 0}, 400, Phaser.Easing.Cubic.Out, true, 1000);
                                this.game.add.tween(this.rightRook)
                                .to({alpha: 0}, 400, Phaser.Easing.Cubic.Out, true, 1000)
                                .onComplete.add(function(): void {

                                    if (!this.game) {
                                        return;
                                    }

                                    this.king.x = .5 * GameConstants.SQUARE_WIDTH;
                                    this.rightRook.x = 3.5 * GameConstants.SQUARE_WIDTH;

                                    this.game.add.tween(this.king)
                                        .to({alpha: 1}, 300, Phaser.Easing.Cubic.Out, true, 500);
                                    this.game.add.tween(this.rightRook)
                                        .to({alpha: 1}, 300, Phaser.Easing.Cubic.Out, true, 500)
                                        .onComplete.add(this.animateCastlingLeftSide, this);


                                }, this);
                    }, this);
            }, this);
    }

    private animateCastlingLeftSide(): void {

        if (!this.game) {
            return;
        }

        this.game.add.tween(this.king)
            .to({x: -1.5 * GameConstants.SQUARE_WIDTH}, 600, Phaser.Easing.Cubic.Out, true, 500)
            .onComplete.add(function(): void {

                if (!this.game) {
                    return;
                }

                this.game.add.tween(this.leftRook)
                    .to({x: -.5 * GameConstants.SQUARE_WIDTH}, 400, Phaser.Easing.Cubic.Out, true, 500)
                    .onComplete.add(function(): void {

                            if (!this.game) {
                                return;
                            }

                                this.game.add.tween(this.king)
                                .to({alpha: 0}, 400, Phaser.Easing.Cubic.Out, true, 1000);
                                this.game.add.tween(this.leftRook)
                                .to({alpha: 0}, 400, Phaser.Easing.Cubic.Out, true, 1000)
                                .onComplete.add(function(): void {

                                    if (!this.game) {
                                        return;
                                    }

                                    this.king.x = .5 * GameConstants.SQUARE_WIDTH;
                                    this.leftRook.x = -3.5 * GameConstants.SQUARE_WIDTH;

                                    this.game.add.tween(this.king)
                                        .to({alpha: 1}, 300, Phaser.Easing.Cubic.Out, true, 500);
                                    this.game.add.tween(this.leftRook)
                                        .to({alpha: 1}, 300, Phaser.Easing.Cubic.Out, true, 500)
                                        .onComplete.add(this.animateCastlingRightSide, this);


                                }, this);
                    }, this);
            }, this);
    }

    private animateEnPassant(): void {

        if (!this.game) {
            return;
        }

        this.enPassantPawnWhite.x = -2.5 * GameConstants.SQUARE_WIDTH;
        this.enPassantPawnWhite.y = -.5 * GameConstants.SQUARE_WIDTH;

        this.enPassantPawnBlack.reset(-1.5 * GameConstants.SQUARE_WIDTH, -2.5 * GameConstants.SQUARE_WIDTH);

        if (this.enPassantPawnWhite.alpha === 0) {

            this.game.add.tween(this.enPassantPawnWhite)
                .to({alpha: 1}, 350, Phaser.Easing.Cubic.Out, true);

            this.enPassantPawnBlack.alpha = 0;

            this.game.add.tween(this.enPassantPawnBlack)
                .to({alpha: 1}, 350, Phaser.Easing.Cubic.Out, true);
        }
        
        this.game.add.tween(this.enPassantPawnBlack)
            .to({y: -.5 * GameConstants.SQUARE_WIDTH}, 500, Phaser.Easing.Cubic.Out, true, 850)
            .onComplete.add(function(): void {

                if (!this.game) {
                    return;
                }

                this.game.add.tween(this.enPassantPawnWhite)
                    .to({x: -1.5 * GameConstants.SQUARE_WIDTH, y: -1.5 * GameConstants.SQUARE_WIDTH}, 500, Phaser.Easing.Cubic.Out, true, 400)
                    .onComplete.add(function(): void {

                        if (!this.game) {
                            return;
                        }

                        this.game.time.events.add(400, function(): void {
                            this.enPassantPawnBlack.kill(false);
                        }, this);

                        this.game.add.tween(this.enPassantPawnWhite)
                            .to({alpha: 0}, 350, Phaser.Easing.Cubic.Out, true, 1200)
                            .onComplete.add( this.animateEnPassant, this);

                    }, this);

            }, this);
    }

    private animateKnigt(): void {

        this.knightIndexMovement = 0;

        this.moveKnight();
    }

    private moveKnight(): void {

        if (!this.game) {
            return;
        }

        let x = InstructionsBoard.KNIGHT_MOVEMENTS[this.knightIndexMovement][0];
        let y = InstructionsBoard.KNIGHT_MOVEMENTS[this.knightIndexMovement][1];

        this.marker.x = x;
        this.marker.y = y;

        let dx: number = Math.abs(this.knight.x - x);
        let tx: number = dx / Piece.PIECE_SPEED;

        let dy: number = Math.abs(this.knight.y - y);
        let ty: number = dy / Piece.PIECE_SPEED;

        if (dx > dy) {
            this.game.add.tween(this.knight)
                .to({x: x}, tx, Phaser.Easing.Cubic.Out, true, 1100)
                .onComplete.add(function(a: any, b: any, c: number[]): void {

                    if (!this.game) {
                        return;
                    }

                    let y: number = c[0];
                    let ty: number = c[1];

                    this.game.add.tween(this.knight)
                        .to({y: y}, ty, Phaser.Easing.Cubic.Out, true)
                        .onComplete.add(this.resetKnightPosition, this);

                }, this, 0, [y, ty]);
        } else {
                this.game.add.tween(this.knight)
                .to({y: y}, ty, Phaser.Easing.Cubic.Out, true, 1100)
                .onComplete.add(function(a: any, b: any, c: number[]): void {

                    if (!this.game) {
                        return;
                    }

                    let x: number = c[0];
                    let tx: number = c[1];

                    this.game.add.tween(this.knight)
                        .to({x: x}, tx, Phaser.Easing.Cubic.Out, true)
                        .onComplete.add(this.resetKnightPosition, this);

                }, this, 0, [x, tx]);
        }

        this.knightIndexMovement = this.knightIndexMovement < InstructionsBoard.KNIGHT_MOVEMENTS.length - 1 ? this.knightIndexMovement + 1 : 0;
    }

    private resetKnightPosition(): void {

        if (!this.game) {
            return;
        }

        // this.game.add.tween(this.marker)
        //     .to({alpha: 0}, 350, Phaser.Easing.Cubic.Out, true);

        this.game.add.tween(this.knight)
            .to({alpha: 0}, 300, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function(): void {

                if (!this.game) {
                    return;
                }

                this.game.add.tween(this.knight)
                    .to({alpha: 1}, 350, Phaser.Easing.Cubic.Out, true);

                this.knight.x = .5 * GameConstants.SQUARE_WIDTH;
                this.knight.y = .5 * GameConstants.SQUARE_WIDTH;

                this.moveKnight();
            }, this);
    }
}
